module.exports = __webpack_public_path__ + "img/水温.40022382.png";